import { defineMessage } from 'services/localization';

export const messages = {
    nsReferenceFieldText: defineMessage('reference'),
    nsTransactionNumberFieldText: defineMessage('transaction_number'),
    nsTermsFieldText: defineMessage('terms'),
    nsDateFieldText: defineMessage('date'),
    nsDueDateFieldText: defineMessage('due_date_1'),
    nsDiscountAmountFieldText: defineMessage('discount_amount'),
    nsDiscountDateFieldText: defineMessage('discount_date'),
    nsIsPaymentHoldFieldText: defineMessage('payment_hold'),
    paymentHoldPositiveValue: defineMessage('yes'),
    paymentHoldNegativeValue: defineMessage('no'),
    nsPostingPeriodFieldText: defineMessage('posting_period'),
    nsMemoFieldText: defineMessage('memo'),
    nsAccountFieldText: defineMessage('account'),
    nsDepartmentFieldText: defineMessage('department'),
    nsClassFieldText: defineMessage('class'),
    nsLocationFieldText: defineMessage('location'),
};
